<template>
  <div>
    <template>
      <v-container>
        <v-row justify="center" align="center">
          <v-col cols="12">
            <Subheader
              icon="mdi-account-supervisor-circle"
              title="Allgemein"
            ></Subheader>
            <div class="mt-7">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-col md="12" cols="12">
                      <v-text-field
                        v-model.trim="roleLocal.title"
                        :counter="35"
                        label="Bezeichnung"
                        :rules="[rules.required]"
                        required
                        outlined
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="12">
                      <v-textarea
                        v-model.trim="roleLocal.description"
                        counter
                        clearable
                        no-resize
                        label="Beschreibung"
                        outlined
                      ></v-textarea>
                    </v-col>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
          <v-col cols="12">
            <v-alert
              type="warning"
              border="left"
              colored-border
              icon="mdi-alert"
              elevation="2"
              class="mt-6"
            >
              <div class="title">Hinweis</div>
              <div class="mt-2">
                Die Steuerung von Berechtigungen für deaktivierte Funktionen ist
                nicht möglich. Sobald die Funktionen einzeln freigeschaltet
                werden, können die Berechtigungen verwaltet werden. Du wirst
                darüber gesondert informiert, um die Berechtigungen deiner
                Rollen entsprechend anzupassen.
              </div>
            </v-alert>
          </v-col>
          <v-col cols="12">
            <Subheader
              icon="mdi-account-supervisor-circle"
              title="Berechtigungen"
            ></Subheader>
            <div class="mt-7">
              <v-card>
                <v-card-text>
                  <v-container>
                    <v-col cols="12" sm="12" md="12">
                      <PermissionTreeView
                        :selected-permissions.sync="roleLocal.permissions"
                        :read-only="false"
                      />
                    </v-col>
                  </v-container>
                </v-card-text>
              </v-card>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </template>
  </div>
</template>

<script>
import Subheader from "@/components/_systemwide/Subheader.vue";
import PermissionTreeView from "@/components/_systemwide/PermissionTreeView.vue";

export default {
  name: "role-editor",
  props: {
    role: {},
    mode: {
      type: String,
      default: "new",
      required: true,
      validator: function (value) {
        return ["new", "edit"].indexOf(value) !== -1;
      },
    },
  },
  components: {
    Subheader,
    PermissionTreeView,
  },
  data() {
    return {
      rules: {
        required: (value) => !!value || "Feld ist erforderlich.",
      },
    };
  },
  model: {
    prop: "role",
    event: "roleChange",
  },
  computed: {
    roleLocal: {
      get: function () {
        return this.role;
      },
      set: function (value) {
        this.$emit("roleChange", value);
      },
    },
  },
};
</script>
